import React from "react";
import {Trans, useTranslation} from "react-i18next";

import {
	TermsButton,
	TermsText,
	TermsTitle,
	type ITermsModalProps,
} from "components/CheckTerms/common";

export const TermsNonBetting: React.FC<ITermsModalProps> = ({trackActionRules, onPlay}) => {
	const {t} = useTranslation();

	return (
		<React.Fragment>
			<TermsTitle>{t("terms_modal.title")}</TermsTitle>
			<TermsText>
				<Trans i18nKey="terms_modal.content.description">
					By clicking "Play Now", I acknowledge that I have read, understand, and agree to
					be bound by the{" "}
					<a
						onClick={trackActionRules}
						target="_blank"
						rel="noreferrer"
						href="https://www.mlb.com/apps/beat-the-streak/official-rules">
						Official Rules
					</a>
					{", "}
					<a
						onClick={trackActionRules}
						target="_blank"
						rel="noreferrer"
						href="https://www.mlb.com/official-information/terms-of-use">
						Terms of Use
					</a>
					, and{" "}
					<a
						onClick={trackActionRules}
						target="_blank"
						rel="noreferrer"
						href="https://www.mlb.com/official-information/privacy-policy">
						MLB Privacy Policies.
					</a>
				</Trans>
			</TermsText>
			<TermsButton type={"button"} onClick={onPlay}>
				{t("terms_modal.button_success")}
			</TermsButton>
			<div className="abbrev-rules">
				<Trans i18nKey="terms_modal.no_purchase">
					NO PURCH. NECESSARY. Open to legal residents of U.S. & Canada (excluding
					Quebec), 21+. Contest ends at conclusion of final game of 2026 regular season.
					Void where prohibited. Restrictions apply; see Official Rules at{" "}
					<a
						target="_blank"
						rel="noreferrer"
						href="https://www.mlb.com/apps/beat-the-streak/official-rules">
						https://www.mlb.com/apps/beat-the-streak/official-rules-ca
					</a>
					. Sponsor: MLB Advanced Media, L.P.
				</Trans>
			</div>
		</React.Fragment>
	);
};
